// Therapist registration

import { createApp } from 'vue/dist/vue.esm-bundler';
import PositionList from './PositionList.vue';

const LpCareerPositionList = document.querySelector('#LpCareerPositionList');

if ( LpCareerPositionList )
{
  createApp({
    components: {
        PositionList
    }
  }).mount('#LpCareerPositionList');
}